import Modal from './component.jsx'
import { ModalContentWrapper } from './baseModal'

export default Modal
export { ModalContentWrapper }
